export const EmployeeFineVI = {

    "EmployeeFineTitle": {
        "date" : "Ngày vi phạm ",
        "violationError" : "Lỗi vi phạm ",
        "money" : "Số tiền ",
        "penaltyForm" : "Hình thức phạt "
    },
    "placeholderFine": {
        "violationError" : "Chọn lỗi vi phạm ",
        "money" : "1,000,000",
        "penaltyForm" : "Hình thức phạt ",
        "Penalized" : "Đã phạt ",
        "employeePaid" : "Nhân viên đã thanh toán ",
        "fromSalary" : "Trừ vào lương ",
        "who" : "Nhân viên chưa nộp phạt trực tiếp trừ vào lương"
    },
    "NotificationEmployeeFine": {
        "edit": "Sửa dữ liệu thành công...",
        "add": "Thêm dữ liệu thành công...",
        "delete": "Xóa dữ liệu thành công...",
    }
}